
import { Component, Vue } from 'vue-property-decorator'
import { Field } from '@/services/utils/baseForm'
import { popUpRoute } from '@/services/utils/popupRoute'
import { sellerEndpoints } from '@/modules/seller'
import { IProduct } from '@/modules/inventory/product/types/productTypes'
import { parsePathQueryString } from '@/shared/helpers/parsePathQueryString'
import { orderItemEndpoints } from '@/modules/order-management/order-items'

@Component({
  name: 'ExportFile',
  components: {
    BaseForm: () =>
      import(
        /* webpackChunkName : "BaseForm"*/ '@/stories/base-form/BaseForm.vue'
      ),
    DialogBaseSkeleton: () =>
      import(
        /* webpackChunkName : "DialogBaseSkeleton"*/ '@/stories/dialog-base-skeleton/DialogBaseSkeleton.vue'
      )
  }
})
export default class ExportFile extends Vue {
  /** function will be passed to child components */
  fields = () => [
    Field.dropdown<IProduct>(
      'merchant',
      'merchantId',
      () => sellerEndpoints.list(),
      'fullName',
      'id'
    )
      .required()
      .setCol('col-12')
  ]

  /** submit the data to the desired endpoint.*/
  async handleSubmit(values: IProduct) {
    const dialogName = parsePathQueryString(location.search)?.dialog

    if (dialogName) {
      await orderItemEndpoints.export({ merchantId: values?.merchantId }, {})
    }
  }

  closePopUp() {
    popUpRoute.removeModalPath(['id'])
  }
}
